import { render, staticRenderFns } from "./ShipmentPickUpOrderModal.vue?vue&type=template&id=8ba4e2fa&scoped=true&"
import script from "./ShipmentPickUpOrderModal.vue?vue&type=script&lang=js&"
export * from "./ShipmentPickUpOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentPickUpOrderModal.vue?vue&type=style&index=0&id=8ba4e2fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba4e2fa",
  null
  
)

export default component.exports